import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserRole } from '../types';

interface UserState {
  currentRole: UserRole;
  userName: string;
  department: string;
}

const initialState: UserState = {
  currentRole: 'HR_LEADER',
  userName: 'HR Analytics User',
  department: 'Human Resources',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserRole: (state, action: PayloadAction<UserRole>) => {
      state.currentRole = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<{ userName: string; department: string }>) => {
      state.userName = action.payload.userName;
      state.department = action.payload.department;
    },
  },
});

export const { setUserRole, setUserInfo } = userSlice.actions;
export default userSlice.reducer;